import React, { useContext } from 'react';
import FacetsToggler from './facetsToggler';
import { ListerActionTypes } from '../../listerReducer';
import { ListerContext } from '../../listerContext';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';

function FacetsTogglerContainer(): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const [{ isListerDisabled, isFacetsDisplayed, breadcrumbs }, dispatch] = useContext(ListerContext);

  const facetsDisplayHandler = (): void => {
    dispatch({ type: ListerActionTypes.SET_IS_FACETS_DISPLAYED, isFacetsDisplayed: !isFacetsDisplayed });
  };

  return (
    <FacetsToggler
      isDisabled={isListerDisabled}
      isFacetsDisplayed={isFacetsDisplayed}
      isFiltersApplied={breadcrumbs.length > 0}
      onClickHandler={facetsDisplayHandler}
      messages={{
        title: formattedMessage({ id: 'search.nav.facets.toggler.title', fallback: 'Filter' }),
        hideFiltersTitle: formattedMessage({
          id: 'search.nav.facets.toggler.hideFilters.title',
          fallback: 'Hide filters'
        }),
        appliedFiltersTitle: formattedMessage({
          id: 'search.nav.facets.toggler.appliedFilters.title',
          fallback: 'Filters applied'
        })
      }}
    />
  );
}

export default FacetsTogglerContainer;
